module.exports = __webpack_public_path__ + "img/multiplier_5_zh.0a2887bc.png";